$.safari = (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) ? true : false;
$.chrome = (navigator.userAgent.indexOf('Chrome') != -1) ? true : false;
$.firefox = (navigator.userAgent.indexOf('Firefox') != -1) ? true : false;
$.ie = (document.documentMode) ? true : false;
$.edge = (navigator.userAgent.indexOf('Edge') != -1) ? true : false;
$.ms = ($.ie || $.edge) ? true : false;

$.windowWidth = $(window).width();
$.windowHeight = $(window).innerHeight();
$.windowAspect = $.windowHeight / $.windowWidth;

$.menuWidth = 600;
$.animSpeed = 400;

$.breakpoint = {
    'sm': 576,
    'md': 768,
    'lg': 992,
    'xl': 1200,
    'e1': 1440,
    'e2': 1680,
    'e3': 1920,
    'e4': 2160,
    'e5': 2400
};

$.color = {
    'blaze': '#ffc20e', // yellow
    'cobalt': '#00427a', // blue
    'crimson': '#c61d23', // red
    'laurel': '#a3a510', // green
    'amethyst': '#652d89', // purple
    'thunderwolf': '#a7a9ac', // grey
    'white': '#ffffff',
    'black': '#000000'
};

$.controller = new ScrollMagic.Controller();

// menu

$.menu_toggle = function() {
    if ($('body').hasClass('menu-active')) {
        $('body').removeClass('menu-active');
    } else {
        $('body').addClass('menu-active');
    }
};

$.menu_init = function() {
    $('#menu-overlay').css('height', $.windowHeight);
    $('#menu-btn').on('click', function(e) {
        e.preventDefault();
        $.menu_toggle();
    });
    $('#menu-container').on('click', 'a', function() {
        $.hash_load = true;
        $.hash_jump = $(this).attr('href');
        $.menu_toggle();
    });
};

// img

$.imgPath = false;
$.imgMd = 1600;
$.imgSm = 480; // 960

$.img_sizes = [
    { 'w' : 480, 'path' : 'sm' }, // 960
    { 'w' : 576, 'path' : 'md' }, // 1280
    { 'w' : 992, 'path' : 'lg' }, // 1920
    { 'w' : 1280, 'path' : 'md' }, // 1280
    { 'w' : 1920, 'path' : 'lg' } // 1920
];

$.img_path = function() {
    var imgPath = false;
    for (var i = 0; i < $.img_sizes.length; i++) {
        var size =  $.img_sizes[i];
        if ($.windowWidth <= size.w) { // path match
            imgPath = '_img-'+ size.path;
            break;
        } // end path match
    }
    $.imgPath = imgPath;
};

$.img_resize = function() {
    var currentImgPath = $.imgPath;
    $.img_path();
    if ($.imgPath != currentImgPath) {
        $('.img-loaded').each(function() {
            var imgResponsive = $(this).data('imgResponsive');
            if (imgResponsive) { // responsive image
                $.img_load(this);
            } // end responsive image
        });
    }
};

$.img_responsive_src = function(imgSrc) {
    if ($.imgPath) {
        var pathArray = imgSrc.split('/');
        var filename = pathArray.pop();
        pathArray.push($.imgPath);
        imgSrc = pathArray.join('/') +'/'+ filename;
    }
    return imgSrc;
};

$.img_src = function(element) {
    var imgSrc = $(element).data('imgSrc');
    var imgResponsive = $(element).data('imgResponsive');
    if (imgResponsive) { // responsive src
        imgSrc = $.img_responsive_src(imgSrc);
    } // end responsive src
    return imgSrc;
};

$.img_load = function(element) {
    $(element).addClass('img-loading');
    var imgSrc = $.img_src(element);
    var imgType = $(element).data('imgType');
    var img = new Image;
    img.onload = function() {
        var imgSrc = this.src;
        switch (imgType) {
            case 'svg':
                $(element).attr('xlink:href', imgSrc);
            break;
            case 'bg':
                $(element).css('background-image', 'url('+ imgSrc +')');
            break;
            default:
                $(element).attr('src', imgSrc);
            break;
        }
        $(element).removeClass('img-loading');
        $.top_margin();
    }
    img.src = imgSrc;
};

$.img_load_next = function(sectionID) {
	var nextSection = $('#'+ sectionID).next('section');
	if ($(nextSection).length) {
		if ($('.img-load',nextSection).length) {
			$('.img-load',nextSection).each(function() {
                $.img_load(this);
				$(this).removeClass('img-load');
                $(this).addClass('img-loaded');
                $.top_margin();
			});
		}
	}
};

$.img_load_init = function() {
    $.img_path();
    $('section').each(function() {
        var sectionID = $(this).attr('id');
        new ScrollMagic.Scene({ triggerElement: '#'+ sectionID, triggerHook: 'onEnter' })
            .on('start', function () {
                $.img_load_next(sectionID);
            })
            .addTo($.controller);
    });
};

// read more

$.read_more_init = function() {
    $('.read-more-content-container').hide();
    $('.read-more-btn a').on('click', function(e) {
        e.preventDefault();
        $.read_more_toggle(this);
    });
};

$.read_more_toggle = function(btn) {
    var parent = $(btn).closest('.read-more');
    if ($(parent).length) {
        var content_container = $('.read-more-content-container',parent);
        if ($(content_container).length) {
            if ($(parent).hasClass('read-more-active')) {
                $(parent).removeClass('read-more-active');
                $(parent).removeClass('read-more-show');
                $(content_container).slideUp($.animSpeed, function() {
                    $.top_margin();
                });
            } else {
                $(parent).addClass('read-more-active');
                $(content_container).slideDown($.animSpeed, function() {
                    $(parent).addClass('read-more-show');
                    $.top_margin();
                });
            }
        }
    }
};

// facts

$.facts_init = function() {
    $('.fact-link a').on('click', function(e) {
        e.preventDefault();
        var container = $(this).closest('.facts');
        if ($(this).hasClass('fact-active')) {
            $('.fact-active', container).removeClass('fact-active');
            $('.fact-default', container).addClass('fact-active');
            $(container).removeClass('fact-active');
        } else {
            var fact = $(this).data('fact');
            $('*', container).removeClass('fact-active');
            $(this).addClass('fact-active');
            $('.'+ fact, container).addClass('fact-active');
            $(container).addClass('fact-active');
        }
        var container_top = $(container).offset().top;
        if ($('html, body').scrollTop() > container_top) {
            $('html, body').animate({
                scrollTop: container_top
            }, 400);
        }
    });
};

// stats

$.stat = 1;

$.stats_animating = false;

$.stats_reset = function() {
    TweenMax.set('#stats', { x: 0 });
    if (!$('.stat-1').hasClass('stat-active')) {
        $('.stat').removeClass('stat-active');
        $('.stat-1').addClass('stat-active');
        $('.stats-svg-background').removeClass('stat-1 stat-2 stat-3 stat-4 stat-5 stat-6');
    }
};

$.stats_move = function() {
    var stats_pos = 0;
    var duration = 0.8;
    $('.stats-svg-background').removeClass('stat-1 stat-2 stat-3 stat-4 stat-5 stat-6').addClass('stat-'+ $.stat);
    $('.stat').each(function(i) {
        if (i) {
            if ($.stat == 1) { // first
                stats_pos -= $(this).outerWidth();
                if ($(this).hasClass('clone')) { // clone reached
                    return false;
                } // end clone reached
            } else { // not first
                if (i < $.stat) {
                    stats_pos -= $(this).outerWidth();
                } else {
                    return false;
                }
            } // end not first
        }
    });
    $('.stat').removeClass('stat-active');
    $('.stat-'+ $.stat).addClass('stat-active');
    $.stats_animating = true;
    TweenMax.to('#stats', duration, { x: stats_pos, ease: Power4.easeOut, onComplete: function() {
            $.stats_animating = false;
            if ($.stat == 1) {
                $.stats_reset();
            }
        }
    });
};

$.stats_init = function() {
    var first_stat = $('.stat-1');
    var second_stat = $('.stat-2');
    if ($(first_stat).length && $(second_stat).length) {
        $(first_stat).clone().addClass('clone').appendTo('#stats');
        $(second_stat).clone().addClass('clone').appendTo('#stats');
        $('.stats-svg-background svg .stat-shapes').clone().removeClass('stat-shapes').addClass('stat-shapes-clone').appendTo('.stats-svg-background svg');
    }
    $('.stat-btn').on('click', function(e) {
        e.preventDefault();
        if (!$.stats_animating) {
            var next = Number($(this).data('next'));
            $.stat = next;
            if ($(this).closest('.stat').hasClass('clone') && $.stat == 2) { // position reset
                $.stats_reset();
            } // end position reset
            $.stats_move();
        }
    });
};

// top margin

$.top_margin_init = function() {
    $.top_margin();
};

$.top_margin = function() {
    $('section').each(function() {
       if (!$(this).hasClass('video-container')) {
            var prev = $(this).prev('section');
            var contentHeight = false;
            if ($('.content-container',prev).length) {
                contentHeight = $('.content-container',prev).outerHeight();
            } else if ($(prev).hasClass('video-container')) {
                contentHeight = $('.share-your-story').outerHeight();
            }
            if (contentHeight) { // set top margin
                var offset = 0;
                if ($(this).hasClass('facts-section')) {
                    offset = 0;
                } else if ($(this).hasClass('stats-section')) {
                    if ($(this).prev('section').hasClass('facts-section')) {
                        offset = 1.25;
                    } else {
                        offset = 1;
                    }
                }
                var marginTop = Math.round(contentHeight - ($.windowHeight * offset));
                if (!$(this).hasClass('stats-section')) {
                    // marginTop = (marginTop < $.windowHeight) ? $.windowHeight : marginTop;
                }
                $(this).css('margin-top', marginTop);
            } // end set top margin
        }
    });
    $.hash_init();
};

// hash

$.hash_load = true;
$.hash_jump = window.location.hash;

$.hash_init = function() {
    if ($.hash_load && $.hash_jump && $($.hash_jump).length) {
        var parentSection = $($.hash_jump).closest('section');
        var parentSectionID = $(parentSection).attr('id');
        var loading = 0;
        $('section').each(function() {
            var sectionID = $(this).attr('id');
            loading += $('.img-load,.img-loading',this).length;
            if (sectionID == parentSectionID) {
                return false;
            }
        });
        if (!loading) {
            window.location.hash = '#loading';
            window.location.hash = $.hash_jump;
            $.hash_load = false;
            $.hash_jump = '';
        }
    }
};

// scroll

$.scrollTolerance = 240;
$.scrollTriggered = false;
$.lastScroll = $.currentScroll = $(window).scrollTop();

$(window).scroll(function() {
    if (!$.scrollTriggered) {
        $.currentScroll = $(window).scrollTop();
        if (Math.abs($.lastScroll - $.currentScroll) > $.scrollTolerance) {
            $('body').removeClass('menu-active');
            $.lastScroll = $.currentScroll;
            $.scrollTriggered = true;
        }
    }
});

// resize

$(window).resize(function() {
    $.windowWidth = $(window).width();
    $.windowHeight = $(window).innerHeight();
    $.windowAspect = $.windowHeight / $.windowWidth;
    $('#menu-overlay').css('height', $.windowHeight);
    $.top_margin();
    $.img_resize();
    $.stats_reset();
});

$(function() {
    if ($.ie) {
        $('body').addClass('ie');
    }
    $.menu_init();
    $.read_more_init();
    $.facts_init();
    $.stats_init();
    $.img_load_init();
    $.top_margin_init();
    $.hash_init();
});
